import React, { FC } from "react";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import { Input, InputLabel, FormControl } from "@mui/material";
interface IInputText {
  controlId: string;
  label?: string;
  handleChange: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any;
  multiple?: boolean;
  [rest: string]: any;
}

/**
 * Input Type File Reusable Component
 *
 * @param {{ controlId: any; label: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, handleChange, handleBlur, errorsField, touched, readOnly, disabled
}
 * @returns {*}
 */
const InputFile: FC<IInputText> = ({
  controlId,
  label,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  multiple,
  ...rest
}) => {
  return (
    <>
      <input
        type="file"
        onChange={handleChange}
        name={controlId}
        multiple={multiple}
        {...rest}
      />
    </>
  );
};

export default InputFile;
